import { useEffect, useState } from 'react';
import { useDataProvider } from 'react-admin';

const limitToCall = 50;

const useUserNotificationsDataProvider = props => {
  const dataProvider = useDataProvider();
  const [fundsData, setFundsData] = useState({ data: [] });
  const [investorsData, setInvestorsData] = useState({ data: [] });
  const [fundInvestorsData, setFundInvestorsData] = useState({ data: [] });

  const [fundIdsIn, setFundIdsIn] = useState([]);
  const [investorIdsIn, setInvestorIdsIn] = useState([]);

  useEffect(() => {
    const _fundIds = {};
    const _investorIds = {};
    props.notifications &&
      Object.values(props.notifications).forEach(notif => {
        if (notif.fundId && notif.fundId !== '*') {
          _fundIds[notif.fundId] = true;
        }
        if (notif.investorId && notif.investorId !== '*') {
          _investorIds[notif.investorId] = true;
        }
      });

    setFundIdsIn(Object.keys(_fundIds));
    setInvestorIdsIn(Object.keys(_investorIds));
  }, [props.notifications, props.key]);

  const [authorizations, setAuthorizations] = useState([]);

  useEffect(() => {
    dataProvider
      .getList('userauthorizations', {
        filter: { userId: props.id }
      })
      .then(({ data }) => {
        setAuthorizations(data);
      });
  }, [dataProvider, props.id, props.key]);

  const [fundIds, setFundIds] = useState({});
  const [investorIds, setInvestorIds] = useState({});
  const [
    fundsWithAllInvestorsAuthorization,
    setfundsWithAllInvestorsAuthorization
  ] = useState({});

  useEffect(() => {
    const _fundIds = {};
    const _investorIds = {};
    const _fundsWithAllInvestorsAuthorization = {};
    authorizations.forEach(authorization => {
      _fundIds[authorization.fundId] = true;
      _investorIds[authorization.investorId] = true;
      authorization.investorId === '*' &&
        (_fundsWithAllInvestorsAuthorization[authorization.fundId] = true);
    });

    setFundIds(Object.keys(_fundIds));
    setInvestorIds(Object.keys(_investorIds));
    setfundsWithAllInvestorsAuthorization(_fundsWithAllInvestorsAuthorization);
  }, [authorizations, props.key]);

  useEffect(() => {
    if (fundIdsIn.length) {
      setFundsData(data => ({ ...data, loading: true }));
      dataProvider
        .getList('funds', {
          filter: { id: `[${fundIdsIn}]` }
        })
        .then(data => {
          setFundsData(data);
        });
    }
  }, [fundIdsIn, dataProvider, props.key]);

  useEffect(() => {
    if (investorIdsIn.length) {
      setInvestorsData(data => ({ ...data, loading: true }));
      dataProvider
        .getList('investors', {
          filter: { id: `[${investorIdsIn}]` }
        })
        .then(data => {
          setInvestorsData(data);
        });
    }
  }, [investorIdsIn, dataProvider, props.key]);

  useEffect(() => {
    if (fundIds.length) {
      setFundInvestorsData(data => ({ ...data, loading: true }));
      const payload = {};
      if (fundIds.length <= limitToCall) {
        payload.filter = { fundId: `[${fundIds}]` };
      }

      dataProvider.getList('fundinvestors', payload).then(data => {
        const {
          loading: isLoadingFundsInvestors,
          data: _fundsInvestors = [],
          error: errorFundsInvestors
        } = data;
        let fundInvestors = [];
        if (
          !isLoadingFundsInvestors &&
          !errorFundsInvestors &&
          _fundsInvestors.length
        ) {
          if (fundIds.length > limitToCall) {
            fundInvestors = _fundsInvestors.filter(
              item =>
                fundIds.includes(item.fundId) &&
                (investorIds.includes(item.investorId) ||
                  fundsWithAllInvestorsAuthorization[item.fundId])
            );
          } else {
            fundInvestors = _fundsInvestors.filter(
              item =>
                investorIds.includes(item.investorId) ||
                fundsWithAllInvestorsAuthorization[item.fundId]
            );
          }
        }
        data.data = fundInvestors;
        setFundInvestorsData(data);
      });
    }
  }, [
    fundIds,
    dataProvider,
    investorIds,
    fundsWithAllInvestorsAuthorization,
    props.key
  ]);

  return {
    fundInvestors: fundInvestorsData,
    funds: fundsData,
    investors: investorsData
  };
};

export default useUserNotificationsDataProvider;
